import { TabContainer } from '@/components/core/TabContainer';
//import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { ChartBarIcon } from '@heroicons/react/24/solid';
//import AssumtionsContent from '../../components/pathwayNavigator/AssumtionsContent';
import DetailsContent from '../../components/pathwayNavigator/DetailsContent';
import { useLoaderData } from 'react-router';

const PathwayNavigatorRoute = () => {
  const { pathwayTemplate } = useLoaderData();

  const tabs = [
    {
      id: 'pathway-details',
      label: (
        <div className="flex items-center gap-2">
          <ChartBarIcon className="w-4 h-4" /> Pathway Details
        </div>
      ),
      content: () => <DetailsContent pathwayTemplate={pathwayTemplate} />,
    },
    /*
    {
      id: 'assumptions',
      label: (
        <div className="flex items-center gap-2">
          <InformationCircleIcon className="w-4 h-4" /> Assumptions
        </div>
      ),
      content: () => <AssumtionsContent />,
    },
    {
      id: 'validation',
      label: (
        <div className="flex items-center gap-2">
          <ExclamationTriangleIcon className="w-4 h-4" /> Validation
        </div>
      ),
      content: () => <>test4</>,
    },*/
  ];

  return (
    <>
      <TabContainer tabs={tabs} defaultTab={tabs[0]?.id} rounded={false} variant="gray" />
    </>
  );
};

export default PathwayNavigatorRoute;
